document.addEventListener('DOMContentLoaded', () => {
  const modalOpinion = document.querySelector('.modal-opinion')
  if (modalOpinion) {
    setTimeout(() => {
      modalOpinion.dispatchEvent(new Event('openModal'))
    }, 2000)
  }
})

